export const LICENSE_MODES =
  Object.freeze({
    NONE:
      'none',

    TERM:
      'term',

    PER_MACHINE:
      'perMachine',
  });


export const RESOURCE_LANGUAGES =
  Object.freeze({
    KO:
      'ko',

    EN:
      'en',
  });

export const RESOURCE_VERSIONS =
  Object.freeze({
    HI_CPS: {
      MANUAL:
        'r2',

      GUIDE_BOOK:
        'v2',
    },

    PG_SOLUTION: {
      MANUAL:
        'ver.0.0',

      GUIDE_BOOK:
        'ver.0.0',
    },

  });

export const RESOURCE_DIRECTORIES =
  Object.freeze({
    HI_CPS:
      'Hi-CPS',

    PG_SOLUTION:
      'PG-Solution',

    HI_LINK:
      'Hi-Link',

    TMS:
      'TMS',
  });


export const RESOURCE_SUB_DIRECTORIES =
  Object.freeze({
    DOWNLOAD:
      'Download',

    MANUAL:
      'Manual',

    GUIDE_BOOK:
      'GuidBook',
  });


export const RESOURCE_FILE_NAMES =
  Object.freeze({
    HI_CPS: {
      PROGRAM:
        'NCAgent_Win11.exe',

      MANUAL:
        'Hi-CPS-Manual',

      GUIDE_BOOK:
        'Hi-CPS-GuidBook',
    },

    PG_SOLUTION: {
      PROGRAM:
        'PGSolution.exe',

      MANUAL:
        'PG-Solution-Manual',

      GUIDE_BOOK:
        'PG-Solution-GuidBook',
    },

    HI_LINK: {
      PROGRAM:
        'Hi-Link.zip',

    },
  });


function buildResourceKey({
  directory,
  subDirectory,
  fileName,
}) {
  return (
    `${directory}/` +
    `${subDirectory}/` +
    `${fileName}`
  );
}


function buildResourcePdfKey({
  directory,
  subDirectory,
  fileName,
  language,
  version,
}) {
  return buildResourceKey({
    directory,
    subDirectory,

    fileName:
      `${fileName}_${language}_${version}.pdf`,
  });
}


export const RESOURCE_FILES =
  Object.freeze({
    HI_CPS: {
      PROGRAM: {
        fileName:
          'NC-AGENT 설치 프로그램',

        resourceKey:
          buildResourceKey({
            directory:
              RESOURCE_DIRECTORIES
                .HI_CPS,

            subDirectory:
              RESOURCE_SUB_DIRECTORIES
                .DOWNLOAD,

            fileName:
              RESOURCE_FILE_NAMES
                .HI_CPS
                .PROGRAM,
          }),
      },


      MANUAL: {
        ko: {
          fileName:
            'Hi-CPS 사용자 매뉴얼',

          resourceKey:
            buildResourcePdfKey({
              directory:
                RESOURCE_DIRECTORIES
                  .HI_CPS,

              subDirectory:
                RESOURCE_SUB_DIRECTORIES
                  .MANUAL,

              fileName:
                RESOURCE_FILE_NAMES
                  .HI_CPS
                  .MANUAL,

              language:
                RESOURCE_LANGUAGES
                  .KO,

              version:
                RESOURCE_VERSIONS
                  .HI_CPS
                  .MANUAL,
            }),
        },


        en: {
          fileName:
            'Hi-CPS User Manual',

          resourceKey:
            buildResourcePdfKey({
              directory:
                RESOURCE_DIRECTORIES
                  .HI_CPS,

              subDirectory:
                RESOURCE_SUB_DIRECTORIES
                  .MANUAL,

              fileName:
                RESOURCE_FILE_NAMES
                  .HI_CPS
                  .MANUAL,

              language:
                RESOURCE_LANGUAGES
                  .EN,

              version:
                RESOURCE_VERSIONS
                  .HI_CPS
                  .MANUAL,
            }),
        },
      },


      GUIDE_BOOK: {
        ko: {
          fileName:
            'Hi-CPS 가이드북',

          resourceKey:
            buildResourcePdfKey({
              directory:
                RESOURCE_DIRECTORIES
                  .HI_CPS,

              subDirectory:
                RESOURCE_SUB_DIRECTORIES
                  .GUIDE_BOOK,

              fileName:
                RESOURCE_FILE_NAMES
                  .HI_CPS
                  .GUIDE_BOOK,

              language:
                RESOURCE_LANGUAGES
                  .KO,

              version:
                RESOURCE_VERSIONS
                  .HI_CPS
                  .GUIDE_BOOK,
            }),
        },


        en: {
          fileName:
            'Hi-CPS Guide Book',

          resourceKey:
            buildResourcePdfKey({
              directory:
                RESOURCE_DIRECTORIES
                  .HI_CPS,

              subDirectory:
                RESOURCE_SUB_DIRECTORIES
                  .GUIDE_BOOK,

              fileName:
                RESOURCE_FILE_NAMES
                  .HI_CPS
                  .GUIDE_BOOK,

              language:
                RESOURCE_LANGUAGES
                  .EN,

              version:
                RESOURCE_VERSIONS
                  .HI_CPS
                  .GUIDE_BOOK,
            }),
        },
      },
    },


    PG_SOLUTION: {
      PROGRAM: {
        fileName:
          'PG-Solution 설치 프로그램',

        resourceKey:
          buildResourceKey({
            directory:
              RESOURCE_DIRECTORIES
                .PG_SOLUTION,

            subDirectory:
              RESOURCE_SUB_DIRECTORIES
                .DOWNLOAD,

            fileName:
              RESOURCE_FILE_NAMES
                .PG_SOLUTION
                .PROGRAM,
          }),
      },


      MANUAL: {
        ko: {
          fileName:
            'PG-Solution 사용자 매뉴얼',

          resourceKey:
            buildResourcePdfKey({
              directory:
                RESOURCE_DIRECTORIES
                  .PG_SOLUTION,

              subDirectory:
                RESOURCE_SUB_DIRECTORIES
                  .MANUAL,

              fileName:
                RESOURCE_FILE_NAMES
                  .PG_SOLUTION
                  .MANUAL,

              language:
                RESOURCE_LANGUAGES
                  .KO,

              version:
                RESOURCE_VERSIONS
                  .PG_SOLUTION
                  .MANUAL,
            }),
        },


        en: {
          fileName:
            'PG-Solution User Manual',

          resourceKey:
            buildResourcePdfKey({
              directory:
                RESOURCE_DIRECTORIES
                  .PG_SOLUTION,

              subDirectory:
                RESOURCE_SUB_DIRECTORIES
                  .MANUAL,

              fileName:
                RESOURCE_FILE_NAMES
                  .PG_SOLUTION
                  .MANUAL,

              language:
                RESOURCE_LANGUAGES
                  .EN,

              version:
                RESOURCE_VERSIONS
                  .PG_SOLUTION
                  .MANUAL,
            }),
        },
      },


      GUIDE_BOOK: {
        ko: {
          fileName:
            'PG-Solution 가이드북',

          resourceKey:
            buildResourcePdfKey({
              directory:
                RESOURCE_DIRECTORIES
                  .PG_SOLUTION,

              subDirectory:
                RESOURCE_SUB_DIRECTORIES
                  .GUIDE_BOOK,

              fileName:
                RESOURCE_FILE_NAMES
                  .PG_SOLUTION
                  .GUIDE_BOOK,

              language:
                RESOURCE_LANGUAGES
                  .KO,

              version:
                RESOURCE_VERSIONS
                  .PG_SOLUTION
                  .GUIDE_BOOK,
            }),
        },


        en: {
          fileName:
            'PG-Solution Guide Book',

          resourceKey:
            buildResourcePdfKey({
              directory:
                RESOURCE_DIRECTORIES
                  .PG_SOLUTION,

              subDirectory:
                RESOURCE_SUB_DIRECTORIES
                  .GUIDE_BOOK,

              fileName:
                RESOURCE_FILE_NAMES
                  .PG_SOLUTION
                  .GUIDE_BOOK,

              language:
                RESOURCE_LANGUAGES
                  .EN,

              version:
                RESOURCE_VERSIONS
                  .PG_SOLUTION
                  .GUIDE_BOOK,
            }),
        },
      },
    },

    HI_LINK: {
      PROGRAM: {
        fileName:
          'Hi-Link 프로그램',

        resourceKey:
          buildResourceKey({
            directory:
              RESOURCE_DIRECTORIES
                .HI_LINK,

            subDirectory:
              RESOURCE_SUB_DIRECTORIES
                .DOWNLOAD,

            fileName:
              RESOURCE_FILE_NAMES
                .HI_LINK
                .PROGRAM,
          }),
      },

      DEVELOPMENT_GUIDE: {
        ko: {
          fileName: 'Hi-Link 개발 가이드',
          resourceKey:
            'Hi-Link/Documents/Hi-Link_V2.0.0_kr.pdf',
        },
        en: {
          fileName: 'Hi-Link Developer Guide',
          resourceKey:
            'Hi-Link/Documents/Hi-Link_V2.0.0_en.pdf',
        },
      },
    },
  });


export const PRODUCT_CATALOG =
  Object.freeze([
    {
      id:
        'hi-cps',

      code:
        'HI_CPS',

      name:
        'Hi-CPS',

      descriptionKey:
        'products.hiCps.description',

      isWebService:
        true,

      machine: {
        managed:
          true,

        hasLimit:
          true,
      },

      license: {
        mode:
          LICENSE_MODES.TERM,
      },

      resources: [
        {
          id:
            'hi-cps-mobile-qr',

          type:
            'mobileQr',

          nameKey:
            'resources.files.hicpsmobileProgram',
        },

        {
          id:
            'nc-agent-program',

          type:
            'program',

          nameKey:
            'resources.files.NcAgentProgram',

          resourceKey:
            RESOURCE_FILES
              .HI_CPS
              .PROGRAM
              .resourceKey,
        },

        {
          id:
            'hi-cps-manual',

          type:
            'manual',

          nameKey:
            'resources.files.hiCpsManual',

          files:
            RESOURCE_FILES
              .HI_CPS
              .MANUAL,
        },

        {
          id:
            'hi-cps-guide',

          type:
            'guide',

          nameKey:
            'resources.files.hiCpsGuide',

          files:
            RESOURCE_FILES
              .HI_CPS
              .GUIDE_BOOK,
        },

      ],
    },


    {
      id:
        'pg-solution',

      code:
        'PG_SOLUTION',

      name:
        'PG-Solution',

      descriptionKey:
        'products.pgSolution.description',

      isWebService:
        false,

      machine: {
        managed:
          false,

        hasLimit:
          false,
      },

      license: {
        mode:
          LICENSE_MODES.TERM,
      },

      resources: [
        {
          id:
            'pg-solution-program',

          type:
            'program',

          nameKey:
            'resources.files.pgSolutionProgram',

          resourceKey:
            RESOURCE_FILES
              .PG_SOLUTION
              .PROGRAM
              .resourceKey,
        },

        {
          id:
            'pg-solution-manual',

          type:
            'manual',

          nameKey:
            'resources.files.pgSolutionManual',

          files:
            RESOURCE_FILES
              .PG_SOLUTION
              .MANUAL,
        },

        {
          id:
            'pg-solution-guide',

          type:
            'guide',

          nameKey:
            'resources.files.pgSolutionGuide',

          files:
            RESOURCE_FILES
              .PG_SOLUTION
              .GUIDE_BOOK,
        },

      ],
    },


    {
      id:
        'hi-link',

      code:
        'HI_LINK',

      name:
        'Hi-Link',

      descriptionKey:
        'products.hiLink.description',

      isWebService:
        false,

      machine: {
        managed:
          false,

        hasLimit:
          true,
      },

      license: {
        mode:
          LICENSE_MODES.TERM,
      },

      resources: [
        {
          id:
            'hi-link-program',

          type:
            'program',

          nameKey:
            'resources.files.hiLinkProgram',

          resourceKey:
            RESOURCE_FILES
              .HI_LINK
              .PROGRAM
              .resourceKey,
        },

        {
          id: 'hi-link-development-guide',
          type: 'manual',
          nameKey: 'resources.files.hiLinkManual',
          files:
            RESOURCE_FILES
              .HI_LINK
              .DEVELOPMENT_GUIDE,
        },

      ],
    },


    {
      id:
        'tms',

      code:
        'TMS',

      name:
        'TMS',

      descriptionKey:
        'products.tms.description',

      isWebService:
        false,

      machine: {
        managed:
          true,

        hasLimit:
          false,
      },

      license: {
        mode:
          LICENSE_MODES.PER_MACHINE,
      },

      resources: [
        {
          id:
            'tms-program',

          type:
            'program',

          nameKey:
            'resources.files.tmsProgram',

          resourceKey:
            buildResourceKey({
              directory:
                RESOURCE_DIRECTORIES.TMS,
              subDirectory:
                RESOURCE_SUB_DIRECTORIES.DOWNLOAD,
              fileName:
                'setup.exe',
            }),
        },

        {
          id:
            'tms-manual',

          type:
            'manual',

          nameKey:
            'resources.files.tmsManual',

          disabled:
            true,
        },

        {
          id:
            'tms-guide',

          type:
            'guide',

          nameKey:
            'resources.files.tmsGuide',

          disabled:
            true,
        },

      ],
    },
  ]);


export function getProductLicenseItems(
  product,
) {
  return [];
}


export function getAssignedLicenseItems(
  product,
) {
  return [];
}


export function getNearestLicenseExpiration(
  licenseItems,
) {
  if (
    !Array.isArray(
      licenseItems,
    )
  ) {
    return null;
  }


  const expirationItems =
    licenseItems
      .map(
        (
          licenseItem,
        ) => {
          const timestamp =
            new Date(
              licenseItem.expiresAt,
            ).getTime();


          return {
            licenseItem,
            timestamp,
          };
        },
      )
      .filter(
        ({
          timestamp,
        }) =>
          Number.isFinite(
            timestamp,
          ),
      )
      .sort(
        (
          firstItem,
          secondItem,
        ) =>
          firstItem.timestamp -
          secondItem.timestamp,
      );


  if (
    expirationItems.length ===
    0
  ) {
    return null;
  }


  const nearestItem =
    expirationItems[0]
      .licenseItem;


  return {
    expiresAt:
      nearestItem.expiresAt,

    machineId:
      nearestItem.machineId ||
      null,

    machineName:
      nearestItem.machineName ||
      null,

    licenseId:
      nearestItem.id ||
      null,
  };
}


export function getProductMachineInformation(
  product,
) {
  if (
    !product?.machine?.managed
  ) {
    return null;
  }


  return {
    registeredCount:
      0,

    maximumCount:
      null,

    hasLimit:
      product.machine.hasLimit ===
      true,

    percentage:
      null,
  };
}


export function getProductLicenseInformation(
  product,
) {
  if (
    !product?.license
  ) {
    return null;
  }


  return {
    mode:
      product.license.mode,

    hasLicense:
      false,

    key:
      null,

    issuedAt:
      null,

    expiresAt:
      null,

    issuedCount:
      0,

    items:
      [],

    nearestExpiration:
      null,

    nearestExpiresAt:
      null,

    nearestMachineName:
      null,
  };
}


export function getProductsWithMachines() {
  return PRODUCT_CATALOG.filter(
    (
      product,
    ) =>
      product.machine !==
      null,
  );
}


export function getProductsWithLicenses() {
  return PRODUCT_CATALOG.filter(
    (
      product,
    ) =>
      product.license !==
      null,
  );
}
